/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Oct-11
 *
 **/

import {validateCURP} from "../core/utils";

const registerFormValidator = {
    username: {
        required: value => !!value || 'El campo Usuario es requerido.',
            min_max: v => v.length >=4 && v.length<=15 || 'Debe ser una cadena de entre 4 y 15 caracteres.',
            valid_char: v => /^\w+$/.test(v) || 'Únicamente son válidos caracteres alfanuméricos y/o guión bajo'
    },
    email: {
        required: value => !!value || 'El campo Email es requerido.',
            valid_email: v =>  /\S+@\S+\.\S+/.test(v) || 'El email no es válido'
    },
    phone: {
        required: value => !!value || 'El campo Email es requerido.',
        digits_10: v => v.length === 10 || 'El número de teléfono debe ser de 10 dígitos',
        isNumber: v => !isNaN(v) || 'Solo se aceptan caracteres numéricos'
    },
    password: {
        required: value => !!value || 'El campo contraseña es requerido.',
        min: v => (!!v && v.length >= 8) || 'Se requiere al menos 8 caracteres',
        passwordMatch: (confirmPassword, password) => confirmPassword === password || 'Las contraseñas no coinciden'
    },
    curp: {
        required: value => !!value || 'El campo CURP es requerido.',
        ws_validate: curp => validateCURP(curp) || 'Ingresa una CURP válida '
    },
    name: {
        required: value => !!value || 'El campo Nombre es requerido.',
    },
    sms_code: {
        required: value => !!value || 'El sms código es requerido.',
    },
    lastname_pat: {
        required: value => !!value || 'El campo Apellido paterno es requerido.',
    },
    rfc: {
        required: value => !!value || 'El campo RFC es requerido.',
        physic_pattern_valid: rfc => !rfc || /^([A-ZÑ\x26]{4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([A-Z]|[0-9]){2}([A-Z]|[0-9]){1})?$/.test(rfc.toUpperCase()) || 'Ingresa un RFC válido para personas físicas.',
        moral_pattern_valid: rfc => /^([A-ZÑ\x26]{3}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([A-Z]|[0-9]){2}([A-Z]|[0-9]){1})?$/.test(rfc.toUpperCase()) || 'Ingresa un RFC válido para personas morales.',
    },

    term_and_condition: {
        required: value => !!value || 'Éste campo es requerido.',
    }
}

export default registerFormValidator;